module.exports = __webpack_public_path__ + "static/media/mk3.c97daebb.jpg";